"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINInfo = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("@iconify/react");
var PINTooltip_1 = require("../PINTooltip");
var utilities_1 = require("../../../utilities");
function PINInfo(_a) {
    var id = _a.id, text = _a.text, className = _a.className, color = _a.color;
    return (react_1.default.createElement(PINTooltip_1.PINTooltip, { id: id, className: className !== null && className !== void 0 ? className : "", text: text },
        react_1.default.createElement(react_2.Icon, { icon: "mdi:information", style: { fontSize: "2rem", color: color ? utilities_1.Colors[color] : utilities_1.Colors.mustaYellow } })));
}
exports.PINInfo = PINInfo;
//# sourceMappingURL=PINInfo.js.map